import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import ListAcademicYears from "./List";
import { StudentServicePath, ACADEMIC_YEARS } from "utils/constants";
import EditAcademicYear from "./Edit";
import CreateAcademicYear from "./Create";
import permissions from "app/permissions";
import ShowAcademicYear from "./Show";

//permissions
export const resources = {
  isMenu: true,
  icon: <EventRepeatIcon />,
  name: StudentServicePath + ACADEMIC_YEARS,
  title: "Академични години",
  list: <ListAcademicYears />,
  create: <CreateAcademicYear />,
  createPermission: permissions.canCreateAcademicYears,
  edit: <EditAcademicYear />,
  editPermission: permissions.canUpdateAcademicYears,
  show: <ShowAcademicYear />,
  permission: permissions.canPreviewAcademicYears,
};
